module.exports = {"id":"211927","name":"Kwon Chang Hoon","rating":"71","photo":"./data/images/photos/3/211927.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["MD","MC","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KwonChangHoon0.json
// module id = 2411
// module chunks = 0